import { sectionContainerAtom } from '@ingenico/react-section-utils';
import deepEqual from 'fast-deep-equal';
import { createStore, Provider } from 'jotai';
import type { ReactElement } from 'react';
import { memo, useMemo } from 'react';
import { deviceManagementContainer } from '../../container.const';
import type { LogicalDeviceConfigurationTabProps } from '../logical-device-configuration-tab/LogicalDeviceConfigurationTab.ctrl';
import { LogicalDeviceConfigurationTab } from '../logical-device-configuration-tab/LogicalDeviceConfigurationTab.ctrl';

function ExposedConfigurationFormBuilderWrapperCpnt({
  onSave,
  selectedApplicationId,
  selectedCategory,
}: LogicalDeviceConfigurationTabProps): ReactElement {
  // Pre-initialize the section container on a fresh store before any child renders, because
  // when loading from another section like provisioning, the component will try to get access
  // to the configuration business service which lives in the device management section.
  // @ingenico/react-section-utils reads sectionContainerAtom synchronously during render and
  // throws if it is null, so the value must be set before the Provider mounts its children.
  const store = useMemo(() => {
    const sectionStore = createStore();
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
    return sectionStore;
  }, []);

  return (
    <Provider store={store}>
      <LogicalDeviceConfigurationTab
        onSave={onSave}
        selectedApplicationId={selectedApplicationId}
        selectedCategory={selectedCategory}
      />
    </Provider>
  );
}

export const ExposedConfigurationFormBuilderWrapperV2 = memo(ExposedConfigurationFormBuilderWrapperCpnt, deepEqual);
